import React, { FC } from "react";
import { useCoupons } from "../../../hooks";
import {
  Alert,
  AlertTitle,
  Checkbox,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";

interface Props {
  setPriceRuleId: (data: number) => void;
  priceRuleId: number;
}

export const Coupons: FC<Props> = ({ priceRuleId, setPriceRuleId }) => {
  const { coupons, getCouponDescription } = useCoupons();
  return (
    <Stack gap={0.5}>
      <Typography variant="subtitle2">Coupons</Typography>
      {coupons && coupons.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          No Coupons Available
        </Typography>
      )}
      {coupons && coupons.length > 0 && (
        <Stack gap={1}>
          {coupons.map((c, index) => (
            <ListItem
              key={c.id}
              dense
              disableGutters
              disablePadding
              secondaryAction={
                <Checkbox
                  checked={priceRuleId === c.id}
                  onChange={e => {
                    if (e.target.checked) {
                      setPriceRuleId(c.id);
                    } else {
                      setPriceRuleId(0);
                    }
                  }}
                />
              }>
              <ListItemText
                primary={c.title}
                secondary={getCouponDescription(index)}
              />
            </ListItem>
          ))}
        </Stack>
      )}
    </Stack>
  );
};
